import { render, staticRenderFns } from "./TaxDialog.vue?vue&type=template&id=8c02fa88&scoped=true"
import script from "./TaxDialog.vue?vue&type=script&lang=js"
export * from "./TaxDialog.vue?vue&type=script&lang=js"
import style0 from "./TaxDialog.vue?vue&type=style&index=0&id=8c02fa88&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c02fa88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c02fa88')) {
      api.createRecord('8c02fa88', component.options)
    } else {
      api.reload('8c02fa88', component.options)
    }
    module.hot.accept("./TaxDialog.vue?vue&type=template&id=8c02fa88&scoped=true", function () {
      api.rerender('8c02fa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/TaxDialog.vue"
export default component.exports